import { BannerResolverType, BannerType } from './banner.types';

export const resolveBannerType = (state: BannerResolverType, dismissedBanners: BannerType[] = []) => {
  const isDismissed = (banner: BannerType) => dismissedBanners.includes(banner);

  switch (true) {
    case state.hasTwilioTokenError && !isDismissed(BannerType.TWILIO_ERROR):
      return BannerType.TWILIO_ERROR;

    case state.showSwitchCall && !isDismissed(BannerType.SWITCH_CALL):
      return BannerType.SWITCH_CALL;

    case state.hasAccountSuspensionWarning && !isDismissed(BannerType.SUSPENSION_WARNING):
      return BannerType.SUSPENSION_WARNING;

    case state.isSuspendedByInsufficientBalance && !isDismissed(BannerType.INSUFFICIENT_BALANCE_SUSPENDED):
      return BannerType.INSUFFICIENT_BALANCE_SUSPENDED;

    case state.showAccountSuspendedBanner && !isDismissed(BannerType.ACCOUNT_SUSPENDED):
      return BannerType.ACCOUNT_SUSPENDED;

    case state.rateLimits && !isDismissed(BannerType.RATE_LIMIT):
      return BannerType.RATE_LIMIT;

    case state.showCallNotSupportedBanner && !isDismissed(BannerType.CALL_NOT_SUPPORTED):
      return BannerType.CALL_NOT_SUPPORTED;

    case state.isNonRenewing && !isDismissed(BannerType.NON_RENEWING):
      return BannerType.NON_RENEWING;

    case !state.hasMicPermission && !isDismissed(BannerType.MIC_PERMISSION):
      return BannerType.MIC_PERMISSION;

    case state.isScheduledDowngradeToBasic && !isDismissed(BannerType.SCHEDULED_DOWNGRADE):
      return BannerType.SCHEDULED_DOWNGRADE;

    case state.isWalletBalanceLow && !isDismissed(BannerType.WALLET_LOW):
      return BannerType.WALLET_LOW;

    // case state.isWalletBalanceMediumLow &&!isDismissed(BannerType.WALLET_MEDIUM_LOW):
    //   return BannerType.WALLET_MEDIUM_LOW;

    case state.isNotificationSilent && !isDismissed(BannerType.NOTIFICATION_SILENT):
      return BannerType.NOTIFICATION_SILENT;

    case state.showMfaReminder && !isDismissed(BannerType.MFA_SETUP_REMINDER):
      return BannerType.MFA_SETUP_REMINDER;
    case state.hasPreferredContact && !isDismissed(BannerType.PREFERRED_CONTACT):
      return BannerType.PREFERRED_CONTACT;

    default:
      return null;
  }
};
